import { useState } from "react";
import { Badge, Card } from "@jaiho/ui";
import type { GameCatalogueEntry } from "@jaiho/shared";
import { GameDetailSheet } from "./GameDetailSheet";
import "./GameCard.css";

const STATUS_LABEL: Record<GameCatalogueEntry["status"], string> = {
  COMING_SOON: "Coming Soon",
  LIVE: "Live",
  DISABLED: "Unavailable",
  MAINTENANCE: "Maintenance",
};

export function GameCard({ game }: { game: GameCatalogueEntry }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Card className="jaiho-game-card" onClick={() => setOpen(true)}>
        <div className={`jaiho-game-card__art jaiho-game-card__art--${game.thumbnailKey}`} />
        <div className="jaiho-game-card__footer">
          <span className="jaiho-game-card__name">{game.name}</span>
          <Badge tone="accent">{STATUS_LABEL[game.status]}</Badge>
        </div>
      </Card>
      {open && <GameDetailSheet game={game} onClose={() => setOpen(false)} />}
    </>
  );
}
